import type { FC } from 'react';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import {
  Grid,
  Card,
  Box,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { numberToMillons } from 'src/utils/functions';
import Panel from '../../../components/global/Panel';
import PanelHeader from '../../../components/global/PanelHeader';
import PanelTitle from '../../../components/global/PanelTitle';
import PanelFilter from '../../../components/admin/PanelFilter';
import TableCellHeaderBasic from '../../../components/global/TableCellHeaderBasic';
import Scrollbar from '../../../components/admin/Scrollbar';
import useIsMountedRef from '../../../hooks/useIsMountedRef';
import { onGet } from '../../../store/actions/global';
import KpiTuberiaFuvex from './KpiTuberiaFuvex';
import KpiTuberiaPie from './KpiTuberiaPie';

const KpiTuberia: FC<any> = ({ onGet: onGetExec }) => {
  const isMountedRef = useIsMountedRef();
  const defaultLimit = 10;
  const title = 'KPI - Tuberia';
  const [valuesFilter, setValuesFilter] = useState({ year: null, month: null });
  const [dataPie, setDataPie] = useState([]);
  const [fuvex, setFuvex] = useState({
    data: [],
    resume: { facturacion: 0, cantidad: 0 },
    pages: { total: 0, current: 0, limit: 0 },
  });
  const [convenio, setConvenio] = useState({
    data: [],
    resume: { facturacion: 0, cantidad: 0 },
    pages: { total: 0, current: 0, limit: 0 },
  });
  const [jfn, setJfn] = useState({
    data: [],
    resume: { facturacion: 0, cantidad: 0 },
    pages: { total: 0, current: 0, limit: 0 },
  });
  const [jfr, setJfr] = useState({
    data: [],
    resume: { facturacion: 0, cantidad: 0 },
    pages: { total: 0, current: 0, limit: 0 },
  });

  const onSubmit = async (values) => {
    if (isMountedRef.current) {
      setValuesFilter(values);
      const response = await onGetExec({
        url: '/dashboard/kpi-tuberia',
        body: { ...values, limit: defaultLimit },
      });
      setDataPie(response?.dataPie);
      setFuvex(response?.fuvex);
      setConvenio(response?.convenio);
      setJfn(response?.jfn);
      setJfr(response?.jfr);
    }
  };

  const headersFuvex = [
    { id: 1, name: 'Canales de Venta' },
    { id: 3, name: 'Operaciones', width: '80px' },
    { id: 2, name: 'Colocación', width: '150px' },
  ];

  const headersFact = [
    { id: 1, name: 'Convenio' },
    { id: 2, name: 'Operaciones', width: '80px' },
    { id: 3, name: 'Colocación', width: '150px' },
  ];

  const headersJFN = [
    { id: 1, name: 'Jefe de Negocio' },
    { id: 2, name: 'Operaciones', width: '80px' },
    { id: 3, name: 'Colocación', width: '150px' },
  ];

  const headersJFR = [
    { id: 1, name: 'Jefe de Relación' },
    { id: 2, name: 'Operaciones', width: '80px' },
    { id: 3, name: 'Colocación', width: '150px' },
  ];

  const handleChangePageFuvex = async (event: unknown, page: number) => {
    const { year, month } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/kpi-tuberia/detail',
      body: {
        year,
        month,
        limit: Number(fuvex.pages.limit),
        page,
        type: 'FUVEX',
      },
    });
    setFuvex(response);
  };

  const handleChangeRowsPerPageFuvex = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { year, month } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/kpi-tuberia/detail',
      body: {
        year,
        month,
        limit: Number(event.target.value),
        page: 0,
        type: 'FUVEX',
      },
    });
    setFuvex(response);
  };

  const handleChangePageConvenio = async (event: unknown, page: number) => {
    const { year, month } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/kpi-tuberia/detail',
      body: {
        year,
        month,
        limit: Number(convenio.pages.limit),
        page,
        type: 'CONVENIO',
      },
    });
    setConvenio(response);
  };

  const handleChangeRowsPerPageConvenio = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { year, month } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/kpi-tuberia/detail',
      body: {
        year,
        month,
        limit: Number(event.target.value),
        page: 0,
        type: 'CONVENIO',
      },
    });
    setConvenio(response);
  };

  const handleChangePageJfn = async (event: unknown, page: number) => {
    const { year, month } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/kpi-tuberia/detail',
      body: {
        year,
        month,
        limit: Number(jfn.pages.limit),
        page,
        type: 'JFN',
      },
    });
    setJfn(response);
  };

  const handleChangeRowsPerPageJfn = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { year, month } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/kpi-tuberia/detail',
      body: {
        year,
        month,
        limit: Number(event.target.value),
        page: 0,
        type: 'JFN',
      },
    });
    setJfn(response);
  };

  const handleChangeRowsPerPageJfr = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { year, month } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/kpi-tuberia/detail',
      body: {
        year,
        month,
        limit: Number(event.target.value),
        page: 0,
        type: 'JFR',
      },
    });
    setJfr(response);
  };

  const handleChangePageJfr = async (event: unknown, page: number) => {
    const { year, month } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/kpi-tuberia/detail',
      body: {
        year,
        month,
        limit: Number(jfr.pages.limit),
        page,
        type: 'JFR',
      },
    });
    setJfr(response);
  };

  return (
    <>
      <Helmet>
        <title>
          Dashboard:
          {title}
        </title>
      </Helmet>
      <Panel>
        <PanelHeader>
          <PanelTitle
            title={title}
            subTitlePrim="Dashboard"
            subTitleSec={title}
          />
        </PanelHeader>
        <PanelFilter onSubmit={onSubmit} yearMonth />
        <Box pt={3}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Card>
                <Scrollbar>
                  <Table size="small" className="zoomin">
                    <TableHead>
                      <TableRow>
                        {headersFuvex.map((header, index) => (
                          <TableCellHeaderBasic
                            key={header.id}
                            width={header.width}
                            align={index !== 0 ? 'right' : 'left'}
                          >
                            {header.name}
                          </TableCellHeaderBasic>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {fuvex.data.map((item) => (
                        <KpiTuberiaFuvex item={item} />
                      ))}
                    </TableBody>
                    <TableHead>
                      <TableRow>
                        <TableCellHeaderBasic>Total</TableCellHeaderBasic>
                        <TableCellHeaderBasic align="right">
                          {fuvex.resume.cantidad}
                        </TableCellHeaderBasic>
                        <TableCellHeaderBasic align="right">
                          {numberToMillons(fuvex.resume.facturacion)}
                        </TableCellHeaderBasic>
                      </TableRow>
                    </TableHead>
                    <TableFooter>
                      <TableRow>
                        <TablePagination
                          rowsPerPageOptions={[5, 10, 15, 20]}
                          labelRowsPerPage="Registros por página"
                          labelDisplayedRows={({ from, to, count }) => `${from} al ${to} de ${count}`}
                          count={fuvex.pages.total}
                          page={fuvex.pages.current}
                          rowsPerPage={fuvex.pages.limit}
                          onPageChange={handleChangePageFuvex}
                          onRowsPerPageChange={handleChangeRowsPerPageFuvex}
                        />
                      </TableRow>
                    </TableFooter>
                  </Table>
                </Scrollbar>
              </Card>
            </Grid>
            <Grid item xs={12} md={6}>
              <Card>
                <Scrollbar>
                  <Table size="small" className="zoomin">
                    <TableHead>
                      <TableRow>
                        {headersFact.map((header, index) => (
                          <TableCellHeaderBasic
                            key={header.id}
                            width={header.width}
                            align={index !== 0 ? 'right' : 'left'}
                          >
                            {header.name}
                          </TableCellHeaderBasic>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {convenio.data.map((item) => (
                        <TableRow key={item.id}>
                          <TableCell>{item.convenio}</TableCell>
                          <TableCell align="right">{item.cantidad}</TableCell>
                          <TableCell align="right">
                            {numberToMillons(item.facturacion)}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                    <TableHead>
                      <TableRow>
                        <TableCellHeaderBasic>Total</TableCellHeaderBasic>
                        <TableCellHeaderBasic align="right">
                          {convenio.resume.cantidad}
                        </TableCellHeaderBasic>
                        <TableCellHeaderBasic align="right">
                          {numberToMillons(convenio.resume.facturacion)}
                        </TableCellHeaderBasic>
                      </TableRow>
                    </TableHead>
                    <TableFooter>
                      <TableRow>
                        <TablePagination
                          rowsPerPageOptions={[5, 10, 15, 20]}
                          labelRowsPerPage="Registros por página"
                          labelDisplayedRows={({ from, to, count }) => `${from} al ${to} de ${count}`}
                          count={convenio.pages.total}
                          page={convenio.pages.current}
                          rowsPerPage={convenio.pages.limit}
                          onPageChange={handleChangePageConvenio}
                          onRowsPerPageChange={handleChangeRowsPerPageConvenio}
                        />
                      </TableRow>
                    </TableFooter>
                  </Table>
                </Scrollbar>
              </Card>
            </Grid>
            <Grid item xs={12} md={6}>
              <Card>
                <Scrollbar>
                  <Table size="small" className="zoomin">
                    <TableHead>
                      <TableRow>
                        {headersJFN.map((header, index) => (
                          <TableCellHeaderBasic
                            key={header.id}
                            width={header.width}
                            align={index !== 0 ? 'right' : 'left'}
                          >
                            {header.name}
                          </TableCellHeaderBasic>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {jfn.data.map((item) => (
                        <TableRow key={item.jfn}>
                          <TableCell>{item.jfn}</TableCell>
                          <TableCell align="right">{item.cantidad}</TableCell>
                          <TableCell align="right">
                            {numberToMillons(item.facturacion)}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                    <TableHead>
                      <TableRow>
                        <TableCellHeaderBasic>Total</TableCellHeaderBasic>
                        <TableCellHeaderBasic align="right">
                          {jfn.resume.cantidad}
                        </TableCellHeaderBasic>
                        <TableCellHeaderBasic align="right">
                          {numberToMillons(jfn.resume.facturacion)}
                        </TableCellHeaderBasic>
                      </TableRow>
                    </TableHead>
                    <TableFooter>
                      <TableRow>
                        <TablePagination
                          rowsPerPageOptions={[5, 10, 15, 20]}
                          labelRowsPerPage="Registros por página"
                          labelDisplayedRows={({ from, to, count }) => `${from} al ${to} de ${count}`}
                          count={jfn.pages.total}
                          page={jfn.pages.current}
                          rowsPerPage={jfn.pages.limit}
                          onPageChange={handleChangePageJfn}
                          onRowsPerPageChange={handleChangeRowsPerPageJfn}
                        />
                      </TableRow>
                    </TableFooter>
                  </Table>
                </Scrollbar>
              </Card>
            </Grid>
            <Grid item xs={12} md={6}>
              <Card>
                <Scrollbar>
                  <Table size="small" className="zoomin">
                    <TableHead>
                      <TableRow>
                        {headersJFR.map((header, index) => (
                          <TableCellHeaderBasic
                            key={header.id}
                            width={header.width}
                            align={index !== 0 ? 'right' : 'left'}
                          >
                            {header.name}
                          </TableCellHeaderBasic>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {jfr.data.map((item) => (
                        <TableRow key={item.jfr}>
                          <TableCell>{item.jfr}</TableCell>
                          <TableCell align="right">{item.cantidad}</TableCell>
                          <TableCell align="right">
                            {numberToMillons(item.facturacion)}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                    <TableHead>
                      <TableRow>
                        <TableCellHeaderBasic>Total</TableCellHeaderBasic>
                        <TableCellHeaderBasic align="right">
                          {jfr.resume.cantidad}
                        </TableCellHeaderBasic>
                        <TableCellHeaderBasic align="right">
                          {numberToMillons(jfr.resume.facturacion)}
                        </TableCellHeaderBasic>
                      </TableRow>
                    </TableHead>
                    <TableFooter>
                      <TableRow>
                        <TablePagination
                          rowsPerPageOptions={[5, 10, 15, 20]}
                          labelRowsPerPage="Registros por página"
                          labelDisplayedRows={({ from, to, count }) => `${from} al ${to} de ${count}`}
                          count={jfr.pages.total}
                          page={jfr.pages.current}
                          rowsPerPage={jfr.pages.limit}
                          onPageChange={handleChangePageJfr}
                          onRowsPerPageChange={handleChangeRowsPerPageJfr}
                        />
                      </TableRow>
                    </TableFooter>
                  </Table>
                </Scrollbar>
              </Card>
            </Grid>
            <Grid item xs={12} md={12}>
              <KpiTuberiaPie content={dataPie} />
            </Grid>
          </Grid>
        </Box>
      </Panel>
    </>
  );
};

export default connect(null, {
  onGet,
})(KpiTuberia);
